import { ChevronDown, LogOut, UserRound } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { Avatar } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useAuthStore } from '@/stores/authStore';
import { ThemeMenuSub } from './theme-menu';

export function HeaderUserProfile() {
  const user = useAuthStore((s) => s.user);
  const signOut = useAuthStore((s) => s.signOut);
  const navigate = useNavigate();
  const name = user?.name ?? 'Account';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="focus-ring flex h-8 shrink-0 items-center gap-1 rounded-sm pl-1 pr-1.5 transition-colors hover:bg-sidebar-accent data-[state=open]:bg-sidebar-accent"
          aria-label={`Account menu for ${name}`}
        >
          <Avatar name={name} size="sm" />
          <ChevronDown className="size-3.5 text-ink-3" aria-hidden="true" />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-60">
        <DropdownMenuLabel className="flex flex-col gap-0.5 py-2">
          <span className="truncate text-sm font-medium text-ink">{name}</span>
          <span className="truncate text-xs font-normal text-ink-3">{user?.email}</span>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {/* Navigates, so it renders as a real link: ⌘-click and middle-click work. */}
        <DropdownMenuItem asChild>
          <Link to="/settings/profile">
            <UserRound />
            Profile
          </Link>
        </DropdownMenuItem>
        <ThemeMenuSub />
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onSelect={async () => {
            await signOut();
            navigate('/signin?signout=true', { replace: true });
          }}
        >
          <LogOut />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
